'use client';

import Icon from '@/components/ui/AppIcon';

interface FilterOption {
  id: string;
  label: string;
  icon: string;
  count: number;
}

interface FilterBarProps {
  activeFilter: string;
  onFilterChange: (filterId: string) => void;
  filters: FilterOption[];
}

export default function FilterBar({ activeFilter, onFilterChange, filters }: FilterBarProps) {
  return (
    <div data-component-id="src/app/services/components/FilterBar.tsx:20:4" data-component-path="src/app/services/components/FilterBar.tsx" data-component-line="20" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20border%20border-border%20rounded-xl%20p-4%20shadow-minimal%22%7D" className="bg-card border border-border rounded-xl p-4 shadow-minimal">
      <div data-component-id="src/app/services/components/FilterBar.tsx:21:6" data-component-path="src/app/services/components/FilterBar.tsx" data-component-line="21" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-3%20overflow-x-auto%20pb-2%20scrollbar-hide%22%7D" className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide">
        {filters.map((filter) => (
          <button data-component-id="src/app/services/components/FilterBar.tsx:23:10" data-component-path="src/app/services/components/FilterBar.tsx" data-component-line="23" data-component-file="FilterBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg font-medium whitespace-nowrap transition-smooth ${
              activeFilter === filter.id
                ? 'bg-primary text-white shadow-atmospheric'
                : 'bg-muted text-foreground hover:bg-primary hover:text-white'
            }`}
          >
            <Icon data-component-id="src/app/services/components/FilterBar.tsx:32:12" data-component-path="src/app/services/components/FilterBar.tsx" data-component-line="32" data-component-file="FilterBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={filter.icon as any} size={20} />
            <span data-component-id="src/app/services/components/FilterBar.tsx:33:12" data-component-path="src/app/services/components/FilterBar.tsx" data-component-line="33" data-component-file="FilterBar.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{filter.label}</span>
            <span data-component-id="src/app/services/components/FilterBar.tsx:34:12" data-component-path="src/app/services/components/FilterBar.tsx" data-component-line="34" data-component-file="FilterBar.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
              activeFilter === filter.id ? 'bg-white bg-opacity-20' : 'bg-background'
            }`}>
              {filter.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}